import type { CategoriesApi } from "@/v2/api/metadata/categories";
import type { ContentTab, DialogTabSaveContext } from "@/v2/framework/dialog/types";
import { createInheritableTabSave } from "@/v2/kits/tenant-inheritance";
import { categoryGamesStatusOptions } from "../../../../shared";
import { categoryId, notifySuccess } from "../shared";

const liveTabChildren: ContentTab["children"] = [
  {
    type: "group",
    name: "liveGame",
    label: "",
    children: [
      {
        type: "select-field",
        name: "status",
        label: "Status",
        required: true,
        placeholder: "Select status",
        options: categoryGamesStatusOptions,
        inheritance: {
          computedKey: "computedStatus",
          parentKey: "parentStatus",
        },
      },
      {
        type: "text-field",
        name: "position",
        label: "Position",
        placeholder: "Enter position",
        inheritance: {
          computedKey: "computedPosition",
          parentKey: "parentPosition",
        },
      },
      {
        type: "structured-array-field",
        name: "displayIds",
        label: "Display IDs",
        minItems: 1,
        maxItems: 50,
        inheritance: {
          computedKey: "computedDisplayIds",
          parentKey: "parentDisplayIds",
        },
        children: [
          {
            type: "text-field",
            name: "prefix",
            label: "",
            placeholder: "Prefix",
            flex: 1,
          },
          {
            type: "text-field",
            name: "rangeFrom",
            label: "",
            placeholder: "From",
            inputType: "number",
            flex: 1,
          },
          {
            type: "text-field",
            name: "rangeTo",
            label: "",
            placeholder: "To",
            inputType: "number",
            flex: 1,
          },
        ],
      },
      {
        type: "select-field",
        name: "defaultEventSelection",
        label: "Default Event Selection",
        placeholder: "Select default event selection for live game",
        required: true,
        options: [
          { value: 1, title: "Selected" },
          { value: 2, title: "Not Selected" },
        ],
        inheritance: {
          computedKey: "defaultEventSelection",
          parentKey: "parentDefaultEventSelection",
        },
      },
    ],
  },
];

export function createLiveTab(categories: CategoriesApi): ContentTab {
  const save = createInheritableTabSave({
    children: liveTabChildren,
    persist: async (patch, ctx: DialogTabSaveContext) => {
      await categories.update(categoryId(ctx.values), patch);
      notifySuccess();
    },
  });

  return {
    id: "live",
    label: "Live",
    save,
    children: liveTabChildren,
  };
}
